<template>
  <div class="container">
    <div class="banner">
      <div class="content">
        <div class="caption">我的课程</div>
        <p>My courses</p>
      </div>
    </div>

    <div class="content myCourses">
      <div class="top-bar flex-sb">
        <div class="flex-fs t-left">
          <div
            :class="{ current: obj.studyState == 1 }"
            @click="requestMyCourseList(1)"
            class="flex-cc"
          >
            学习中
          </div>
          <div
            :class="{ current: obj.studyState == 2 }"
            @click="requestMyCourseList(2)"
            class="flex-cc"
          >
            已完成
          </div>
        </div>
        <!-- <div class="flex-fs t-right">
          <div class="flex-cc">
            目标学时 <span>{{ courseTime }}小时</span>
          </div>
          <div class="flex-cc">
            已学学时 <span>{{ studyTime }}小时</span>
          </div>
        </div> -->
      </div>
      <div class="myCourses-list">
        <ul class="flex-fs">
          <li v-for="item in courseList">
            <div class="img">
              <img :src="getFullImageUrl(item.course.coursePic)" />
            </div>
            <div class="box">
              <div class="title">
                {{ item.course && item.course.courseTitle }}
              </div>
              <div class="progess flex-fs">
                <span :class="{ wanchen: obj.studyState == 2 }"
                  >学习进度{{
                    progess(item.studyTime, item.course.courseTime, "%")
                  }}
                </span>
                <div>
                  <el-progress
                    class="pro"
                    :percentage="
                      progess(item.studyTime, item.course.courseTime)
                    "
                    :show-text="false"
                  ></el-progress>
                </div>
              </div>
              <div
                @click="toPage(item.courseId, item.ucId)"
                class="btn flex-cc"
              >
                继续学习
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="pages flex-cc" v-if="courseTotalNum > 8">
      <el-pagination
        @current-change="changePage"
        background
        :page-size="8"
        :page-sizes="[]"
        layout="prev, pager, next"
        :total="courseTotalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { myCourseList } from "@/api";
import { Loading } from "element-ui";
export default {
  name: "MyCourses",

  data() {
    return {
      obj: {
        studyState: 1,
        pageSize: 8,
        pageNum: 1,
      },
      courseList: [],
      courseTotalNum: 0,
      courseTime: 0,
      studyTime: 0,
    };
  },

  mounted() {
    this.requestMyCourseList(1);
  },
  methods: {
    requestMyCourseList(studyState) {
      let loadingInstance = Loading.service({ fullscreen: true });
      this.obj.studyState = studyState;
      myCourseList({
        studyState: this.obj.studyState,
        pageSize: 8,
        pageNum: this.obj.pageNum,
      })
        .then((res) => {
          if (res.code == 200) {
            this.courseList = res.rows;
            this.courseTotalNum = res.total;
            let courseTime = 0;
            let studyTime = 0;
            this.courseList.forEach((item) => {
              courseTime += item.course.courseTime;
              studyTime += item.studyTime;
            });
            this.courseTime = courseTime;
            this.studyTime = studyTime;
          }
        })
        .finally(() => {
          loadingInstance.close();
        });
    },
    changePage(pageNum) {
      this.obj.pageNum = pageNum;
      this.requestMyCourseList();
    },
    progess(studyTime, courseTime, symbol = false) {
      if (studyTime == 0) {
        return 0;
      }
      let key = `${((studyTime / courseTime) * 100).toFixed(0)}${
        symbol ? "%" : ""
      }`;
      return key;
    },
    toPage(courseId, ucId) {
      // 生成一个随机页面ID，也可以用时间戳
      this.pageId = Math.random().toString(36).substr(2, 9);

      // 检查是否已有播放页面打开
      const existingPageId = localStorage.getItem("unique_playing_page");
      if (existingPageId && existingPageId !== "null") {
        console.log(
          `🚀 ~ toPage ~ existingPageId && existingPageId !== "false":`,
          existingPageId && existingPageId !== "false"
        );

        // 如果已经有播放页面打开，且不是自己，则提示并关闭当前页面
        if (existingPageId !== this.pageId) {
          this.$notify({
            title: "提示",
            message: "只能在一个窗口观看课程视频",
            type: "warning",
          });
        }
      } else {
        this.$router.push({
          path: "/coursesDetails",
          query: { courseId, ucId },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background: #f3f4f8;

  .banner {
    min-width: 1600px;
    color: #fff;
    height: 510px;
    background: url("../assets/image/kec.png");
    background-size: 100% 100%;
    padding-top: 170px;
    .content {
      padding-left: 150px;
    }
    .caption {
      font-size: 46px;
      font-weight: bold;
    }
    p {
      font-size: 12px;
      padding-top: 5px;
    }
  }
  .myCourses {
    padding-bottom: 80px;
    .top-bar {
      margin-bottom: 82px;
      .t-left {
        margin-top: 20px;
        div {
          width: 186px;
          height: 56px;
          font-size: 18px;
          color: #000;
          border: 1px solid #ddd;
          border-radius: 30px;
          margin-right: 30px;
          cursor: pointer;

          &.current,
          &:hover {
            color: #fff;
            background: #1265cc;
            border-color: #1265cc;
          }
        }
      }

      .t-right {
        margin-top: 32px;
        div {
          background: #e4f1ff;
          width: 244px;
          height: 92px;
          font-size: 20px;
          color: #000;
          margin-left: 22px;
          border-radius: 8px;
          span {
            color: #1265cc;
            font-size: 26px;
            padding-left: 10px;
          }
        }
      }
    }
    /////
    .myCourses-list {
      ul {
        flex-wrap: wrap;
        li {
          margin-left: 88px;
          &:nth-child(4n + 1) {
            margin-left: 0;
          }
          background: #fff;
          width: 334px;
          margin-bottom: 65px;
          .img {
            height: 220px;
            overflow: hidden;
            background-size: cover;
            img {
              width: 100%;
              height: 220px;
            }
          }
          .box {
            height: 185px;
            border: 1px solid #eee;
            border-top: 0;
            .title {
              padding: 16px 15px 0;
              font-size: 16px;
              color: #000;
              height: 60px;
              margin-bottom: 25px;
              display: -webkit-box;
              -webkit-line-clamp: 2; /* 限制显示的行数为2 */
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
            .progess {
              font-size: 16px;
              padding-left: 15px;
              color: #666;
              span {
                padding-right: 20px;
                width: 120px;
                &.wanchen {
                  width: 135px;
                  padding-right: 0;
                }
              }
              div {
                .pro {
                  width: 160px;
                }
              }
            }
            .btn {
              height: 50px;
              width: 298px;
              color: #000;
              font-size: 16px;
              border: 1px solid #eee;
              margin: 16px auto 0;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .pages {
    padding-bottom: 100px;
  }
}
</style>
